import './SearchSuggestion.scss'

import { cls } from '@react/utils/classname'
import { ReactElement } from 'react'

type SearchSuggestionProps = {
  suggestion: string
  hidden: boolean
  label: string
}

export function SearchSuggestion({ suggestion, hidden, label }: SearchSuggestionProps): ReactElement {
  const updateSearchInputValue = () => {
    const searchInputs = document.querySelectorAll('.cmp-saas__search-input')
    if (searchInputs.length) {
      searchInputs?.forEach((element: HTMLInputElement) => (element.value = suggestion))
    }
  }
  return (
    <div className={cls({ 'saas-search-results--is-hidden': hidden, 'saas-suggestions__wrapper': true })}>
      <span className="saas-suggestions__message" data-testid="search-suggestion-label">
        {label}
      </span>
      <ul className="saas-suggestions__list">
        <li className="saas-sugestion__item">
          <span className="saas-sugestion__item-link" onClick={updateSearchInputValue} data-testid="search-suggestion-suggestion">
            {suggestion}
          </span>
          ?
        </li>
      </ul>
    </div>
  )
}
